
const state = {
    status: '',
    regions: [],
    auth: {
        resource: {
            projectIdxs: [],
            projects: [],
            myOwnProjects: [],
            additionalProjects: [],
            groups: [],
            groupAuthorityMap: {},
            accountMap: {},
            groupProjectMap: {}
        },
        prerequisites: [],
        needPrerequisite: false,
        message: undefined,
        userInfo: {},
        serviceGroups: [],
        requiredService: ''
    },
    changeProject: {
        event: '',
        value: null
    },
    selectedGroup: null,
    selectedProject: null,
    selectedMonth: '',
    selectedMonthRange: [],
    months: [],
    privacy: {
        versions: [],
        document: {}
    },
    tags: [],
    boardDocumentsStatus: '',
    boardDocuments: [],
    boardDocument: null,
    hasInvoice: false
}

export default state
